// extracted by mini-css-extract-plugin
module.exports = {"text":"articleBody-module--text--fM2KX","text__firstText":"articleBody-module--text__firstText--2PKsS"};